import { render, staticRenderFns } from "./colTitle.vue?vue&type=template&id=6d2c9c3a&scoped=true&"
import script from "./colTitle.vue?vue&type=script&lang=ts&"
export * from "./colTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c9c3a",
  null
  
)

export default component.exports